import React from 'react';
import {
  Typography,
  Box,
  Divider
} from '@mui/material';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip
} from 'recharts';
import { Card } from 'Components/Card'


const defaultColors = ['#0033A0', '#0055D4', '#007BFF', '#3399FF', '#66B2FF'];

const DonutChartCard = ({ title, total, data, colors = defaultColors }) => {
  return (
    <Card sx={{ textAlign: 'center' }}>
      {/* Título */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
      </Box>

      {/* Gráfico de Pizza com total no centro */}
      <Box position="relative" display="flex" justifyContent="center" alignItems="center">
        <ResponsiveContainer width="100%" height={195}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={80}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>

        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{ transform: 'translate(-50%, -50%)', textAlign: 'center' }}
        >
          <Typography variant="h6" fontWeight="bold">Total</Typography>
          <Typography variant="h5" fontWeight="bold" color="gray">{total}</Typography>
        </Box>

      </Box>

      <Divider sx={{ my: 1 }} />

      {/* Legenda */}
      <Box
        mt={1}
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(150px, 1fr))"
        gap={1}
      >
        {data.map((item, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={1}
          >
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  backgroundColor: colors[index % colors.length],
                  mr: 1.5
                }}
              />
              <Typography variant="body2">{item.name}</Typography>
            </Box>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: colors[index % colors.length] }}
            >
              {item.percent}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default DonutChartCard;
